let context: AudioContext | undefined;

/** A short tone for scan feedback. Silent where WebAudio is unavailable or blocked. */
export function playBeep(kind: 'ok' | 'error' = 'ok'): void {
  try {
    const Ctor: typeof AudioContext | undefined =
      typeof AudioContext === 'undefined' ? undefined : AudioContext;
    if (!Ctor) return;
    context ??= new Ctor();
    if (context.state === 'suspended') void context.resume();
    const osc = context.createOscillator();
    const gain = context.createGain();
    osc.type = kind === 'ok' ? 'sine' : 'square';
    osc.frequency.value = kind === 'ok' ? 1100 : 220;
    gain.gain.value = 0.12;
    osc.connect(gain);
    gain.connect(context.destination);
    const now = context.currentTime;
    osc.start(now);
    osc.stop(now + (kind === 'ok' ? 0.09 : 0.25));
  } catch (err) {
    console.warn('Beep unavailable.', err);
  }
}
